/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCompany, getCompany } from "../../../../reducers/companySlice";
import companyService from "../../../../utils/services/company";
import { useDispatch } from "react-redux";
import {
  selectLoadingUI,
  loadingOn,
  loadingOff,
} from "../../../../reducers/uiSlice";
import Toolbar from "../../../card/toolbar";
import { Notification } from "../../../../containers/notification";
import { useSnackbar } from "notistack";
import { selectUser } from "../../../../reducers/userSlice";
import {
  selectChangesDeposit,
  setChanges,
} from "../../../../reducers/depositSlice";
import { useChangeRecord } from "../../../../utils/hooks/useChangeRecord";
import dateUtils from "../../../../utils/date";
import InputComponent from "../../../inputs";

import logo from "../../../../assets/img/tagManager.png";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useNavigate } from "react-router-dom";

// CSS

import styles from "./styles.module.css";

export default function GoogleTagManager() {
  const [gtmID, setGtmID] = useState("");
  const [updated, setUpdated] = useState(false);
  const company = useSelector(selectCompany);
  const user = useSelector(selectUser);
  const loading = useSelector(selectLoadingUI);
  const changes = useSelector(selectChangesDeposit);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { recordChange } = useChangeRecord();

  useEffect(() => {
    if (company.GoogleAnalytics) initialize();
  }, [company]);

  const initialize = () => {
    if (company.GoogleAnalytics) {
      setGtmID(company.GoogleAnalytics.GTMID);
    }
  };

  const updateChanges = (fieldName, newValue) => {
    const newChanges = [];
    newChanges.push(...changes);
    var index = -1;
    const change = {
      text: "",
      oldValue: null,
      newValue: null,
      date: dateUtils.getUTC().slice(0, 19).replace("T", " "),
    };

    change.newValue = newValue;
    change.oldValue =
      company && company.GoogleAnalytics && company.GoogleAnalytics[fieldName]
        ? company.GoogleAnalytics[fieldName]
        : "";

    switch (fieldName) {
      case "GTMID":
        change.text = "Cambios en el Tag Manager ID de la tienda";
        break;
      default:
        break;
    }

    index = newChanges.findIndex(
      (item) => item.text.toString() === change.text.toString()
    );

    if (index !== -1) {
      change.oldValue = newChanges[index].oldValue;
      newChanges[index] = change;
    } else {
      newChanges.push(change);
    }
    dispatch(setChanges(newChanges));
  };

  const handleCancel = () => initialize();

  const handleSave = () => {
    dispatch(loadingOn());
    companyService
      .updateCompany(
        company._id,
        {
          _id: company._id,
          GoogleAnalytics: {
            ...company.GoogleAnalytics,
            GTMID: gtmID,
          },
        },
        user.token
      )
      .then(async () => {
        dispatch(loadingOff());
        getCompany(company._id, dispatch);
        enqueueSnackbar(
          Notification({
            text: "Datos de la tienda actualizados",
            variant: "success",
            withDetails: false,
          })
        );
        setUpdated(false);
        await recordChange({
          module: "Configuraciones",
          submodule: "Google Tag Manager",
          changes: changes,
        });
      })
      .catch((err) => {
        enqueueSnackbar(
          Notification({
            text: "Error al actualizar datos de la tienda",
            variant: "error",
            withDetails: false,
          })
        );
        dispatch(loadingOff());
      });
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div className={styles.parentContainer}>
      <button className={styles.backButton} onClick={() => handleClose()}>
        <span>
          <ArrowBackIcon />
        </span>
        Regresar
      </button>
      <div className={styles.infoContainer}>
        <div className={styles.titleLogoContainer}>
          <Toolbar title="Google Tag Manager" />
          <img src={logo} alt="log" className={styles.imageElement} />
        </div>
        <div className={styles.infoDataContainer}>
          <p className={styles.textDescription}>
            Google Tag Manager es una herramienta que te permitirá simplificar
            el seguimiento de lo que ocurre en tu tienda.
          </p>
          <div className={styles.inputStackContainer}>
            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>Tag Manager ID</label>

              <InputComponent
                className={styles.inputElement}
                placeholder="Ej. GTM-123456"
                type="text"
                handler={(e) => {
                  setUpdated(true);
                  updateChanges("GTMID", e.target.value);
                  setGtmID(e.target.value);
                }}
                disabled={loading}
                validation={gtmID === ""}
                value={gtmID}
              />
            </div>

            <div className={styles.buttonsContainer}>
              <button
                disabled={!updated}
                onClick={() => {
                  setUpdated(true);
                  handleCancel();
                }}
                className={styles.cancelButton}
              >
                {" "}
                Cancelar
              </button>
              <button
                disabled={!updated}
                className={styles.confirmButton}
                onClick={() => {
                  setUpdated(true);
                  handleSave();
                }}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
